<label class="searchbox" [class.dirty]="!!searchInput.value">
  <eb-spinner
    *ngIf="(isSearching | async) && searchTermLength > 1"
    isSearchBoxSpinner="true"
    [size]="1"
    class="searchbox__spinner"
  ></eb-spinner>
  <ng-container *ngIf="searchTermLength > 1 && !(isSearching | async)">
    <button
      class="eb-search-box__submit-button"
      (click)="
        close($event, true);
        launchSearchResult($event, searchInput.value);
        updateChosenWord(searchInput.value)
      "
    >
      <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
    </button>
  </ng-container>
  <input
    #searchInput
    [class]="isVisible ? 'searchbox-is-visible' : ''"
    [placeholder]="'searchBox.placeholder' | cxTranslate"
    autocomplete="off"
    aria-describedby="initialDescription"
    aria-controls="results"
    aria-autocomplete="both"
    [attr.aria-label]="'common.search' | cxTranslate"
    (focus)="open()"
    (click)="open()"
    (input)="search(searchInput.value)"
    (blur)="close($event)"
    (keydown.escape)="close($event)"
    (keydown.enter)="
      close($event, true);
      launchSearchResult($event, searchInput.value);
      updateChosenWord(searchInput.value)
    "
    (keydown.arrowup)="focusPreviousChild($event)"
    (keydown.arrowdown)="focusNextChild($event)"
    value="{{ chosenWord }}"
  />

  <button
    [attr.aria-label]="'common.reset' | cxTranslate"
    (mousedown)="clear()"
    (keydown.enter)="clear()"
    class="reset"
  >
    <cx-icon [type]="iconTypes.RESET"></cx-icon>
  </button>

  <div role="presentation" class="search-icon">
    <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
  </div>

  <button [attr.aria-label]="'common.search' | cxTranslate" class="search" (click)="open()">
    <cx-icon [type]="iconTypes.SEARCH"></cx-icon>
  </button>
</label>

<ng-container *ngIf="results$ | async as result">
  <div
    *ngIf="result.products?.length > 0"
    class="results"
    [class.has-results]="result.products"
    id="results"
    (click)="close($event, true)"
    role="listbox"
  >
    <ul
      class="products"
      attr.aria-label="{{ 'searchBox.ariaLabelProducts' | cxTranslate }}"
      tabindex="0"
    >
      <li *ngFor="let product of result.products" class="eb-search-box__item">
        <a
          [routerLink]="getProductUrl(result, product) | cxUrl"
          [queryParams]="
            result.keywordRedirectUrl ? getQueryParams(result.keywordRedirectUrl) : null
          "
          [class.has-media]="config.displayProductImages"
          (keydown.arrowup)="focusPreviousChild($event)"
          (keydown.arrowdown)="focusNextChild($event)"
          (keydown.enter)="close($event, true)"
          (keydown.escape)="close($event, true)"
          (blur)="close($event)"
          (mousedown)="preventDefault($event)"
          class="eb-search-box__item-link"
          (click)="
            dispatchProductEvent({
              freeText: searchInput.value,
              productCode: product.code
            })
          "
        >
          <cx-media
            *ngIf="config.displayProductImages"
            [container]="product.images?.PRIMARY"
            format="thumbnail"
            role="presentation"
          ></cx-media>
          <div class="name" [innerHTML]="product.nameHtml"></div>
        </a>
      </li>
    </ul>
    <span id="initialDescription" class="cx-visually-hidden">
      {{ 'searchBox.initialDescription' | cxTranslate }}
    </span>
    <div *ngIf="result.products?.length" aria-live="assertive" class="cx-visually-hidden">
      {{ 'searchBox.suggestionsResult' | cxTranslate: { count: result.suggestions?.length } }}
      {{ 'searchBox.productsResult' | cxTranslate: { count: result.products?.length } }}
      {{ 'searchBox.initialDescription' | cxTranslate }}
    </div>
  </div>
</ng-container>
